export default __webpack_public_path__ + "static/media/painscale_5.d4e753bc.png";